import React from 'react';
import { PlayIcon, PauseIcon, ChevronUpIcon } from 'lucide-react';
import { useAudioPlayer } from '../context/AudioPlayerContext';
export function MiniPlayer({
  onExpand
}) {
  const {
    currentTrack,
    isPlaying,
    togglePlayPause,
    currentTime,
    duration
  } = useAudioPlayer();
  if (!currentTrack) return null;
  const progress = duration ? currentTime / duration * 100 : 0;
  return <div className="h-16 bg-white border-t shadow-sm flex items-center px-4 cursor-pointer" onClick={onExpand} data-id="element-102">
      <button className="h-10 w-10 rounded-full bg-blue-500 flex items-center justify-center text-white mr-3 flex-shrink-0" onClick={e => {
      e.stopPropagation();
      togglePlayPause();
    }} data-id="element-103">
        {isPlaying ? <PauseIcon className="h-5 w-5" data-id="element-104" /> : <PlayIcon className="h-5 w-5" data-id="element-105" />}
      </button>
      <div className="flex-1 min-w-0" data-id="element-106">
        <h4 className="font-medium text-gray-800 truncate" data-id="element-107">
          {currentTrack.title}
        </h4>
        <p className="text-sm text-gray-500 truncate" data-id="element-108">
          Speaker: {currentTrack.speaker}
        </p>
        <div className="w-full bg-gray-200 h-1 rounded-full mt-1" data-id="element-109">
          <div className="bg-blue-500 h-1 rounded-full" style={{
          width: `${progress}%`
        }} data-id="element-110" />
        </div>
      </div>
      <ChevronUpIcon className="h-5 w-5 text-gray-400 ml-3 flex-shrink-0" data-id="element-111" />
    </div>;
}